<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.hospitalisations', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
<!--                <div class="card-title">-->
<!--                    <router-link :to="{ name: 'add-hospitalisation' }" v-if="can">-->
<!--                        {{ $t('message.add') }}-->

<!--                        <i class="fas fa-plus-circle edit-icon"></i>-->
<!--                    </router-link>-->
<!--                </div>-->

                <template v-if="rows">
                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mHospitalisations"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="hospitalisations-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mHospitalisations"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data">
                            <div class="row" v-if="data.item.isAuthor || hasAdminRole">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-hospitalisation', params: { hospitalisation: data.item.slug } }">
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.hospitalisations', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deleteHospitalisation(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            class="justify-content-center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="hospitalisations-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "Hospitalisations",

        computed: {
            ...mapGetters(["hospitalisations",
                'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                'hasPraticienRole']),

            mHospitalisations: function() {
                let hArray = [];

                _.forEach(this.hospitalisations, function(hospitalisation) {
                    let h = {};

                    h.patient = hospitalisation.dossier.numero_dossier;
                    h.date_entree = moment(hospitalisation.date_entree).format('YYYY/MM/DD HH:mm');
                    h.date_sortie = hospitalisation.date_sortie == null ? '' : moment(hospitalisation.date_sortie).format('YYYY/MM/DD HH:mm');
                    h.date = moment(hospitalisation.created_at).format('DD-MM-YYYY HH:mm');
                    h.id = hospitalisation.id;
                    h.slug = hospitalisation.slug;
                    h.isAuthor = hospitalisation.isAuthor;

                    hArray.push(h);
                });

                return hArray;
            },

            rows: function() {
                return this.mHospitalisations.length;
            },
            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },

        },

        data() {
            return {
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'patient',
                        label: this.$i18n.tc('message.patients', 1),
                    },
                    {
                        key: 'date_entree',
                        label: this.$i18n.t('message.entryDate'),
                        sortable: true
                    },
                    {
                        key: 'date_sortie',
                        label: this.$i18n.t('message.exitDate'),
                        sortable: true
                    },
                    {
                        key: 'date',
                        label: this.$i18n.t('message.createdAt'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getHospitalisations() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getHospitalisations', { args : args });
            },

            formattedDisplay (result) {
                return result.title;
            },

            itemSelected(item) {
                this.$router.push({ name: 'hospitalisation', params: { hospitalisation: item.selectedObject.slug } });
            },

            rowSelected(items) {
                this.$router.push({ name: 'hospitalisation', params: { hospitalisation: items[0].slug } });
            },

            deleteHospitalisation(hospitalisation) {
                let self = this;

                let args = {
                    hospitalisation: hospitalisation
                };

                let successMessage = this.$i18n.t('message.hospitalisationDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteHospitalisation', { args, index: hospitalisation, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + hospitalisation);
                    });
            }
        },

        mounted() {
            // Fetch hospitalisation list
            this.getHospitalisations();
        }
    }
</script>

<style scoped>

</style>